/* SET STATE */
export const SET_STATE_NORMSLIBRARY = "SET_STATE_NORMSLIBRARY"

/* NORMSLIBRARYS */
export const GET_NORMSLIBRARYS = "GET_NORMSLIBRARYS"
export const GET_NORMSLIBRARYS_SUCCESS = "GET_NORMSLIBRARYS_SUCCESS"
export const GET_NORMSLIBRARYS_FAIL = "GET_NORMSLIBRARYS_FAIL"

/* NORMSLIBRARY */
export const GET_NORMSLIBRARY = "GET_NORMSLIBRARY"
export const GET_NORMSLIBRARY_SUCCESS = "GET_NORMSLIBRARY_SUCCESS"
export const GET_NORMSLIBRARY_FAIL = "GET_NORMSLIBRARY_FAIL"

/**
 * ADD NORMSLIBRARY
 */
 export const ADD_NEW_NORMSLIBRARY = "ADD_NEW_NORMSLIBRARY"
 export const ADD_NORMSLIBRARY_SUCCESS = "ADD_NORMSLIBRARY_SUCCESS"
 export const ADD_NORMSLIBRARY_FAIL = "ADD_NORMSLIBRARY_FAIL"

 /**
 * UPDATE NORMSLIBRARY
 */
export const UPDATE_NORMSLIBRARY = "UPDATE_NORMSLIBRARY"
export const UPDATE_NORMSLIBRARY_SUCCESS = "UPDATE_NORMSLIBRARY_SUCCESS"
export const UPDATE_NORMSLIBRARY_FAIL = "UPDATE_NORMSLIBRARY_FAIL"

/**
 * DELETE NORMSLIBRARY
 */
export const DELETE_NORMSLIBRARY = "DELETE_NORMSLIBRARY"
export const DELETE_NORMSLIBRARY_SUCCESS = "DELETE_NORMSLIBRARY_SUCCESS"
export const DELETE_NORMSLIBRARY_FAIL = "DELETE_NORMSLIBRARY_FAIL"
